export default "__VITE_ASSET__hr$adlIW__"